import { createSymbols } from 'utils/helpers';
import { collectionReducer } from 'utils/reducerGenerator';

export const {
    TRANSFER_FUNDS,
    TRANSFER_FUNDS_FAIL,
    TRANSFER_FUNDS_SUCCESS,
} = createSymbols([
    'TRANSFER_FUNDS',
    'TRANSFER_FUNDS_FAIL',
    'TRANSFER_FUNDS_SUCCESS',
]);

const transferFunds = (state) => state.set('isTransferring', true);
const transferFundsFail = (state) => state.set('isTransferring', false);
const transferFundsSuccess = (state) => state
    .set('isTransferring', false)
    .set('hasTransferred', true);

const transactions = collectionReducer(
    { namespace: 'TRANSACTION' },
    {
        [TRANSFER_FUNDS]: transferFunds,
        [TRANSFER_FUNDS_FAIL]: transferFundsFail,
        [TRANSFER_FUNDS_SUCCESS]: transferFundsSuccess,
    }
);

export const { EDIT_IN, FETCH, FETCH_FAIL, FETCH_SUCCESS } = transactions.types;

export default transactions.reducer;
